import { render, staticRenderFns } from "./childrenOrderDetail.vue?vue&type=template&id=526e0ea2&scoped=true&"
import script from "./childrenOrderDetail.vue?vue&type=script&lang=js&"
export * from "./childrenOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./childrenOrderDetail.vue?vue&type=style&index=0&id=526e0ea2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526e0ea2",
  null
  
)

export default component.exports